/* import __COLOCATED_TEMPLATE__ from './editable-attribute-column.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-management */
import Component from '@glimmer/component';
import type TicketAttributeSummary from 'embercom/objects/inbox/ticket-attribute-summary';

interface Args {
  attribute: TicketAttributeSummary;
  formSubmitted: boolean;
}

interface Signature {
  Args: Args;
}

export default class EditableAttributeColumn extends Component<Signature> {
  get showError(): boolean {
    return this.args.formSubmitted && this.args.attribute.showErrorOnCreate;
  }

  get descriptor() {
    return this.args.attribute.descriptor;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::TicketAttribute::EditableAttributeColumn': typeof EditableAttributeColumn;
    'inbox2/ticket-attribute/editable-attribute-column': typeof EditableAttributeColumn;
  }
}
